import React, {useState, useEffect} from 'react'
import { useTranslation } from "react-i18next";
import { LIMIT_PAGE } from "constants/variables";
import Box from '@mui/material/Box';   
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage'; 
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import TextField from '@mui/material/TextField';
import useTheme from '@mui/material/styles/useTheme';   
import visuallyHidden from '@mui/utils/visuallyHidden';
import { NumericFormat } from 'components/utils/NumericFormat';
import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsStoresPrices = [
  {
    id: 'typesofprice_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_Typesofprice',
    canOrder:true,
  },
  {
    id: 'saleprice',
    numeric: true,
    disablePadding: false,
    label: 'Text_SalePrice',
    canOrder:false,
  }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
  
function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
        return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {headCellsStoresPrices.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 14}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
 
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataArticles']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export const TableSortingStoresPrices =(props)=>{
  const { dataStoresPrices, 
    setFormArticle, 
    numTotRegStoresPrice} = props;
  const {t,i18n} = useTranslation(['listDataArticles']);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataStoresPrices.length) : 0);
  const [countData,setCountData] = useState(dataStoresPrices.length);

  const [activeOffsetPrice, setactiveOffsetPricePrice]= useState(false);
  const [currencyOffsetPrice, setcurrencyOffsetPricePrice] = useState(1);
  const [rangeOffsetPrice, setrangeOffsetPricePrice] = useState([{}]);

    useEffect(() => {
      if (dataStoresPrices.length !== countData || dataStoresPrices.length <= rowsPerPage) {
        setPage(0);
      }  
      setCountData(dataStoresPrices.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataStoresPrices.length) : 0);
    }, [dataStoresPrices, rowsPerPage, page, countData]);
    
    useEffect(() => {
      if (numTotRegStoresPrice > LIMIT_PAGE) {
        setactiveOffsetPricePrice(true);
        const ranges = [
          {
            value: 1,
            label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
          },
        ];
        for (let i = Number(LIMIT_PAGE); i < numTotRegStoresPrice; i += Number(LIMIT_PAGE)) {
          ranges.push({
            value: (i / Number(LIMIT_PAGE)) + 1,
            label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
          });
        }
        setrangeOffsetPricePrice(ranges);
      } else {
        setcurrencyOffsetPricePrice(1);
        setactiveOffsetPricePrice(false);
        setrangeOffsetPricePrice([{}]);
      }
    }, [numTotRegStoresPrice]);

  const handleChangeOffset = (event) => {
    setcurrencyOffsetPricePrice(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000) return true;
    return false;
  };

  const handleBlurArticlesAmount = (value, row) => {
    handleChangeArticleAmount(value, row);
  };

 const handleChangeArticleAmount = (value, row) => {
    setFormArticle((prev) => ({
      ...prev,
      articlestoretypesofprices: prev.articlestoretypesofprices.map((item) =>
        item.indexrowstypesofprices === row.indexrowstypesofprices
          ? { ...item, saleprice: value }
          : item
      )
    }));
  };

  const listItemsPrice= (
  stableSort(dataStoresPrices, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, keydataStoresPrices) => {
    return (
      <TableRow hover tabIndex={-1} key={keydataStoresPrices}> 
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {i18n.language==="es"?row.typesofprice_namees:row.typesofprice_nameen}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <NumericFormat 
            thousandSeparator={','} 
            decimalSeparator={'.'} 
            decimalScale= {2}
            suffix={" €"}
            fixedDecimalScale= {true}
            allowNegative= {false}
            isAllowed={withValueCap}
            id="saleprice" 
            name="saleprice"
            value={row.saleprice}
            className="numeric-field"
            label={t('PlaceHolder_Saleprice')}
            placeholder={t('PlaceHolder_Saleprice')}  
            onBlur={() => handleBlurArticlesAmount(row.saleprice, row)}
            onValueChange={(values) => handleChangeArticleAmount(values.floatValue ?? 0, row)}
          /> 
        </TableCell>
       </TableRow>
    );
  }));

  return(
    <>
      <Box sx={{ width: '100%' }}> 
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '100%',width: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t}/>
              <TableBody>    
                {listItemsPrice}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={2} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetPrice && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetPrice"
                            name="currencyOffsetPrice"
                            value={currencyOffsetPrice}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetPrice
                            }}>
                            {rangeOffsetPrice.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={9}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingStoresPrices.propTypes = {
  dataStoresPrices: PropTypes.array.isRequired,
  setFormArticle: PropTypes.func.isRequired, 
  numTotRegStoresPrice: PropTypes.number.isRequired,   
};

export default TableSortingStoresPrices;